<template>
  <v-row dense>
    <v-col v-for="splitTitle in splitThrough" :key="splitTitle">
      <v-card class="fill-height">
        <v-container fluid>
          <v-row dense>
            <v-col class="text-h5">
              {{ splitTitle }}
            </v-col>
          </v-row>

          <v-divider />

          <v-row
            dense
            v-for="(values, shardTitle) in consolidatedInfo[splitTitle]"
            :key="shardTitle"
          >
            <v-col>
              <v-row dense>
                <v-col class="text-subtitle-2 gray--text text--lighten-1">
                  {{ shardTitle }}
                </v-col>
              </v-row>

              <v-row dense v-for="value in values" :key="value">
                <v-col>
                  {{ value }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "DynamicFormConsolidatedInfo",
    props: {
      consolidatedInfo: Object,
      consolidateInfoOption: Object,
    },
    computed: {
      splitThrough() {
        return this.consolidateInfoOption.group_by.split_through;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
